import { render } from "./AlphaMannosidosisLeukocytes.vue?vue&type=template&id=46c68d8f&scoped=true"
import script from "./AlphaMannosidosisLeukocytes.vue?vue&type=script&lang=js"
export * from "./AlphaMannosidosisLeukocytes.vue?vue&type=script&lang=js"

import "./AlphaMannosidosisLeukocytes.vue?vue&type=style&index=0&id=46c68d8f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c68d8f"]])

export default __exports__